import React from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import App from './app';
import GmailAddonPopup from './app/screens/sharing/components/sharing-details-popup/components/gmail-add-on-popup';
import i18n from './i18n';


/**
 * We check the url if the user is from Gmail add on popup we navigate the user to GmailAddonPopup
 */

class CheckApp extends React.Component {



  componentDidUpdate(){
    let queryParameter = queryString.parse(this.props.location.search);
    queryParameter?.userLanguage?i18n.changeLanguage(queryParameter.userLanguage):i18n.changeLanguage(this.props.language);
  }

  render() {
    let queryParameter = queryString.parse(this.props.location.search);
    if (
      queryParameter.action === 'new' ||
      queryParameter.action === 'edit' ||
      queryParameter.action === 'share' ||
      queryParameter.action === 'add' ||
      queryParameter.action === 'view'||
      queryParameter.action === 'addNotes' ||
      queryParameter.action === 'viewNotes'||
      queryParameter.action === 'addToAContact'||
      queryParameter.action === 'createNewContact'


    ) {
      i18n.changeLanguage(queryParameter.userLanguage)
      return <GmailAddonPopup />;
    } else {
      return <App />;
    }
  }
}
const mapStateToProps = (state) => ({
	language: state.languageReducer.language,
});

export default withRouter(connect(mapStateToProps, null)(CheckApp));
